import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['excluded'];

  declare readonly excludedTargets: HTMLElement[];

  private restoreExcluded = (): void => {
    this.excludedTargets.forEach((target) => target.classList.remove('d-print-none'));
  };

  connect(): void {
    window.addEventListener('afterprint', this.restoreExcluded);
  }

  disconnect(): void {
    window.removeEventListener('afterprint', this.restoreExcluded);
  }

  call(): void {
    this.excludedTargets.forEach((target) => target.classList.add('d-print-none'));
    window.print();
  }
}
